<div
  class="relative order-last flex h-10 items-center justify-center gap-2 overflow-hidden rounded-2xl border border-states-purple/20 bg-other-toolbar-purple p-1 max-[1176px]:flex-grow"
  [class]="transcriptionStatus() === 'recording' ? 'min-[1176px]:order-none' : 'min-[1092px]:order-none'"
>
  @for (item of contextMenuHeaderConfig(); track item.text) {
    <button
      type="button"
      (click)="onButtonClick(item.type)"
      [disabled]="isGenerating() || transcriptionStatus() !== 'idle'"
      class="flex items-center justify-center gap-1 self-stretch overflow-hidden rounded-xl bg-background-white px-4 py-1 text-states-purple transition-colors disabled:bg-other-voice-control disabled:opacity-40 max-[1176px]:flex-grow"
      [ngClass]="{
        '!bg-states-purple text-text-white': isGenerating() && currentEnhanceType() === item.type
      }"
    >
      @if (
        isGenerating() &&
        (item.type === GenerateTextAction.NoteRewrite ||
          item.type === GenerateTextAction.CollabRewrite ||
          item.type === GenerateTextAction.HealthHistoryRewrite) &&
        isCurrentEnhanceTypeRewrite()
      ) {
        <ng-lottie
          currentcolor
          class="h-4 w-4 text-states-purple"
          [ngClass]="{
            'text-text-white': isGenerating()
          }"
          [options]="enhanceLottieOptions()"
        ></ng-lottie>
      } @else {
        <svg-icon class="h-8 w-8 shrink-0" [key]="getIconKey(item.type)" [fontSize]="16"></svg-icon>
      }
      <span class="typo-h5-semibold">{{ item.text | translate }}</span>
    </button>
  }
</div>
